/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ReservationsTableRequest} from 'types/requests/ReservationsTableRequest'
import {Reservation} from 'types/entities/Reservation'
import { DEFAULT_RESERVATIONS_TABLE_SORTING } from 'utils/reservations/reservationTableUtils'

export interface OnlineReservationsState {
    reservations: Reservation[]
    tableState: ReservationsTableRequest
}

const initialState: OnlineReservationsState = {
    reservations: [],
    tableState: {
        filter: {},
        page: 0,
        per_page: 50,
        search: [{ id: 'status', value: ['reserved'] }],
        sorting: [...DEFAULT_RESERVATIONS_TABLE_SORTING],
    },
}

const onlineReservationsSlice = createSlice({
    name: 'onlineReservations',
    initialState,
    reducers: {
        setReservations(state, action: PayloadAction<Reservation[]>) {
            state.reservations = action.payload
        },
        setReservation(state, action: PayloadAction<Reservation>) {
            const index = state.reservations.findIndex((r) => r.id === action.payload.id)
            if (index === -1) state.reservations.push(action.payload)
            else state.reservations[index] = action.payload
        },
        setTableState(state, action: PayloadAction<ReservationsTableRequest>) {
            state.tableState = action.payload
        },
        clearReservations(state) {
            state.reservations = []
        },
        clearTableState(state) {
            state.tableState = initialState.tableState
        },
        resetState: () => initialState,
    },
})

export const { setReservations, setReservation, setTableState, clearReservations, clearTableState, resetState } =
    onlineReservationsSlice.actions

export default onlineReservationsSlice.reducer
